import React from 'react';
import { DefaultBsComponent } from '../../types/module';
import { classNames } from '../../utils/style';

import { AuthorDate } from './AuthorDate';
import { AuthorInfos } from './AuthorInfos';
import { AuthorImage } from './AuthorImage';
import { AuthorName } from './AuthorName';
import { AuthorPosition } from './AuthorPosition';
import { AuthorReadingTime } from './AuthorReadingTime';

export const AuthorComponent = ({
  className,
  children,
  as: Component = 'div',
  ...props
}: DefaultBsComponent) => {
  return (
    <Component
      {...props}
      className={classNames('Author', className, 'flex flex-row items-center')}
    >
      {children}
    </Component>
  );
};

export const Author = Object.assign(AuthorComponent, {
  Image: AuthorImage,
  Name: AuthorName,
  Position: AuthorPosition,
  Date: AuthorDate,
  ReadingTime: AuthorReadingTime,
  Infos: AuthorInfos,
});
